const CHANGE_WINTER_TIME_RANGE = "CHANGE_WINTER_TIME_RANGE";

const winterTimeRangeAction = (name, value) => {
  return {
    type: CHANGE_WINTER_TIME_RANGE,
    payload: { name, value },
  };
};

const handleWinterTimeRange = (name, value) => {
  return (dispatch) => {
    dispatch(winterTimeRangeAction(name, value));
  };
};

export { handleWinterTimeRange, CHANGE_WINTER_TIME_RANGE };
